import { Overlay } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  Overlay,
  React
};